var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "vendor-attachment",
      attrs: { id: "vendors-bids-attachment" },
    },
    [
      _c(
        "ul",
        {
          staticClass: "accordion",
          attrs: {
            id: "vendors-bids-attachment-accordion",
            "data-accordion": "",
            "data-multi-expand": "true",
            "data-allow-all-closed": "true",
          },
        },
        [
          _c(
            "li",
            {
              staticClass: "accordion-item is-active",
              attrs: {
                id: "vendors-bids-attachment-hkld-panel",
                "data-accordion-item": "",
              },
            },
            [
              _c("a", { staticClass: "accordion-title" }, [
                _vm._v(_vm._s(_vm.$t("tender.tenderAttachment"))),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "accordion-content",
                  attrs: { "data-tab-content": "" },
                },
                [
                  _c("attachments", {
                    attrs: {
                      files: _vm.engineerFiles,
                      showTenderHints: true,
                      zipName: _vm.zipPrefix + "_Attachments.zip",
                    },
                    on: {
                      "update:files": function ($event) {
                        _vm.engineerFiles = $event
                      },
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _vm.editView
            ? _c(
                "li",
                {
                  staticClass: "accordion-item is-active",
                  attrs: {
                    id: "vendors-bids-attachment-vendor-panel",
                    "data-accordion-item": "",
                  },
                },
                [
                  _c("a", { staticClass: "accordion-title" }, [
                    _vm._v(_vm._s(_vm.$t("vendor.attachment.vendor"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "accordion-content",
                      attrs: { "data-tab-content": "" },
                    },
                    [
                      _c("pre", [
                        _vm._v("          "),
                        _c(
                          "p",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.attachmentDesc,
                                expression: "attachmentDesc",
                              },
                            ],
                            staticClass: "upload-instructions",
                          },
                          [_vm._v(_vm._s(_vm.attachmentDesc))]
                        ),
                        _vm._v("\n        "),
                      ]),
                      _vm._v(" "),
                      _c("FileUpload", {
                        attrs: {
                          attachment: _vm.attachment,
                          resourceId: _vm.tenderBidId,
                        },
                        on: {
                          "update:attachment": function ($event) {
                            _vm.attachment = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.editView
            ? _c(
                "li",
                {
                  staticClass: "accordion-item is-active",
                  attrs: {
                    id: "vendors-bids-attachment-hkld-panel",
                    "data-accordion-item": "",
                  },
                },
                [
                  _c("a", { staticClass: "accordion-title" }, [
                    _vm._v(_vm._s(_vm.$t("vendor.attachment.vendor"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "accordion-content",
                      attrs: { "data-tab-content": "" },
                    },
                    [
                      _c(
                        "p",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.attachmentDesc,
                              expression: "attachmentDesc",
                            },
                          ],
                          staticClass: "upload-instructions",
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.attachmentDesc) +
                              "\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("attachments", {
                        attrs: {
                          files: _vm.vendorFiles,
                          noHighlight: true,
                          zipName: _vm.zipPrefix + "_Vendor_Attachments.zip",
                        },
                        on: {
                          "update:files": function ($event) {
                            _vm.vendorFiles = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }